<template>
    <component
        :is="isExternalLinkFlag ? 'a' : 'nuxt-link'"
        v-bind="linkAttributes"
        class="award_image"
        :aria-label="label"
    >
        <picture v-full-image-path:assets.decorative="picture" />
    </component>
</template>

<script>
import isExternalLink from '@/helpers/isExternalLink';

export default {
    props: {
        awardItem: {
            type: Object,
            required: true
        },

        picture: {
            type: String,
            default: ''
        },

        label: {
            type: String,
            default: ''
        }
    },

    computed: {
        link() {
            return this.awardItem.link;
        },

        isExternalLinkFlag() {
            return isExternalLink(this.link);
        },

        linkAttributes() {
            if (this.isExternalLinkFlag) {
                return {
                    href: this.link,
                    target: '_blank',
                    rel: 'noopener noreferrer'
                };
            }

            return {
                to: this.localePath(this.link)
            };
        }
    }
};
</script>
